import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { LineDetails } from "../types";
import { makeSessionJsonStorage, withPrefix } from "./storage";

//global state for selected line IDs (ordered, not persisted - synced via URL)
export const selectedLineIdsAtom = atom<string[]>([]);

// active line avoids per tab (sessionStorage) to avoid cross-tab flicker
export const activeLineIdAtom = atomWithStorage<string | null>(
  withPrefix("active-line-id"),
  null,
  makeSessionJsonStorage<string | null>()
);

// Cache of stops per line 
export const lineParentStopsAtom = atom<Record<string, string[]>>({});

// Cache of line details by ID (
export const linesByIdAtom = atom(new Map<string, LineDetails>());

// In-flight promises for line details fetches (to deduplicate requests)
export const linesInFlightAtom = atom(new Map<string, Promise<LineDetails>>());
